import React from 'react';

export const OrganizationSettingContext = React.createContext(
    {}
);
